const reducer = (state = {},action) => {
    return state;
}

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/entities/article.js